import { completionOf, currentModuleOf } from '../program/derive';
import { useProgramFull } from '../program/use-program-full';

/** The learner's place in the program, derived from the cached program. */
export function useLearnerPosition() {
  return useProgramFull((program) => {
    const currentModule = currentModuleOf(program);
    const module = program.modules.find((item) => item.number === currentModule);
    return {
      currentModule,
      totalModules: program.modules.length,
      completionPercent: completionOf(program),
      module: { number: module?.number ?? 1, title: module?.title ?? program.title },
    };
  });
}
